import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { ThreeDots } from "react-loader-spinner";
//primereact
import { InputOtp } from "primereact/inputotp";
//assets
import logo from "../../assets/logo.png";
import darkLogo from "../../assets/darkLogo.png";
//services
import { getResendCode } from "../../services/Login/getResendCode";
import { postVerifyEmail } from "../../services/Login/postVerifyEmail";
//context
import { useAppContext } from "../../context/AppContext";
import { toast } from "react-toastify";

const VerifyEmail = () => {
  const form = useForm();
  const { state } = useLocation();
  const navigate = useNavigate();
  const [foto, setFoto] = useState(logo);
  const [token, setTokens] = useState();
  const [loading, setLoading] = useState(false);

  const {
    handleSetAppSidebarNone,
    handleSetAppHeaderNone,
    handleSetAppContentClass,
  } = useAppContext();

  const getDark = localStorage.getItem("appDarkMode");

  const onSubmit = async () => {
    setLoading(true);
    const data = {
      cod: token,
      environment_id: state.environment_id,
    };
    const notification = toast.loading("Por favor aguarde...");
    try {
      await postVerifyEmail(data);
      toast.update(notification, {
        render: "Acesso Liberado!",
        autoClose: 1000,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
      navigate("/");
    } catch (error) {
      toast.update(notification, {
        render: error.response.data.error ?? "Código inválido!",
        autoClose: 1000,
        theme: "colored",
        type: "error",
        isLoading: false,
      });
    }
    setLoading(false);
  };

  const resendEmail = async () => {
    setLoading(true);
    const notification = toast.loading("Por favor aguarde...");
    try {
      await getResendCode(state.environment_id);
      toast.update(notification, {
        render: "E-mail enviado!",
        autoClose: 1000,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
    } catch (error) {
      toast.update(notification, {
        render: "Não foi possível reenviar o e-mail",
        autoClose: 1000,
        theme: "colored",
        type: "warning",
        isLoading: false,
      });
    }
    setLoading(false);
  };

  useEffect(() => {
    if (getDark === "true") {
      setFoto(logo);
    } else {
      setFoto(darkLogo);
    }
  }, [getDark]);

  useEffect(() => {
    handleSetAppSidebarNone(true);
    handleSetAppHeaderNone(true);
    handleSetAppContentClass("p-0");

    return () => {
      handleSetAppSidebarNone(false);
      handleSetAppHeaderNone(false);
      handleSetAppContentClass("");
    };
  }, [
    handleSetAppSidebarNone,
    handleSetAppHeaderNone,
    handleSetAppContentClass,
  ]);

  return (
    <div className="login login-v1">
      <div className="login-container">
        <div className="login-header">
          <div className="brand">
            <div className="d-flex align-items-center">
              <img src={foto} width={250} alt="Logo IB3 Capital" />
            </div>
          </div>
          <div className="icon">
            <i className="fa fa-lock"></i>
          </div>
        </div>
        <div className="login-body">
          <div className="login-content fs-13px">
            <form onSubmit={form.handleSubmit(onSubmit)}>
              <p>Informe o código que foi enviado no e-mail: </p>
              <div className="d-flex justify-content-center my-4">
                <InputOtp
                  value={token}
                  length={8}
                  onChange={(e) => setTokens(e.value)}
                />
              </div>
              <div className="login-buttons">
                <button
                  type="submit"
                  disabled={loading}
                  className="btn h-45px btn-blue d-flex align-items-center justify-content-center w-100 btn-lg"
                >
                  {loading ? (
                    <ThreeDots
                      height="80"
                      width="80"
                      radius="9"
                      color="#fff"
                      ariaLabel="three-dots-loading"
                      wrapperStyle={{}}
                      wrapperClassName=""
                      visible={true}
                    />
                  ) : (
                    <>Enviar</>
                  )}
                </button>

                <div className="text-center pt-2">
                  <b>
                    <div
                      style={{
                        cursor: "pointer",
                        textDecoration: "underline",
                      }}
                      onClick={() => resendEmail()}
                      className="text-gray bg-transparent border-none"
                    >
                      Reenviar o e-mail{" "}
                      <i className="fa-solid fa-repeat ms-2"></i>
                    </div>
                  </b>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;
